import { t } from "@/i18n-js/instance";
import { SITE_THEMES } from "@/react/components/shared/BuilderUI/SiteThemes/constants";
import { BuilderUI } from "@circle-react-shared/BuilderUI";
import { defaultBlocks } from "@circle-react-shared/BuilderUI/DefaultBlocks";
import { defaultData as mockRootBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/Root/RootDefaultData";
import { TabContainer } from "../../components/TabContainer";
import { CheckoutPreview } from "./CheckoutPreview";

export const CheckoutTab = () => (
  <TabContainer variants="full-width" className="h-full w-full">
    <BuilderUI.Provider
      // Check in later PRs if we need these presets
      theme={SITE_THEMES.defaultTheme}
      block={mockRootBlock}
      blockMapping={defaultBlocks}
      canvasSize="desktop"
    >
      <BuilderUI.Shell>
        <BuilderUI.FixedLeftSidebar>
          <BuilderUI.SidebarHeader>
            <BuilderUI.SidebarHeaderTitle>
              {t("builder_ui.example.editor_title")}
            </BuilderUI.SidebarHeaderTitle>
            <BuilderUI.SidebarActions />
          </BuilderUI.SidebarHeader>
          <BuilderUI.Editor />
        </BuilderUI.FixedLeftSidebar>
        <BuilderUI.Main>
          <BuilderUI.Canvas>
            <BuilderUI.CanvasControls>
              <BuilderUI.CanvasSizeToggle />
            </BuilderUI.CanvasControls>
            <BuilderUI.CanvasZoomableSize>
              <BuilderUI.CanvasCard className="h-[95%]">
                <CheckoutPreview />
              </BuilderUI.CanvasCard>
            </BuilderUI.CanvasZoomableSize>
            <BuilderUI.FullscreenPreview />
          </BuilderUI.Canvas>
        </BuilderUI.Main>
      </BuilderUI.Shell>
      <BuilderUI.KeyboardShortcuts />
    </BuilderUI.Provider>
  </TabContainer>
);
